import React from "react";

const Comfoair350 = () => {
  return (
    <svg
      width="100%"
      height="100%"
      version="1.1"
      viewBox="0 0 105.83 66.146"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="d"
          x1="37.099"
          x2="43.714"
          y1="75.302"
          y2="75.302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00f" stopOpacity="0" offset="0" />
          <stop stopColor="#00f" offset="1" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="133.67"
          x2="138.96"
          y1="75.302"
          y2="75.302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fd0000" offset="0" />
          <stop stopColor="#fd0000" stopOpacity="0" offset="1" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="43.714"
          x2="109.86"
          y1="58.104"
          y2="75.302"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" offset="0" />
          <stop stopColor="#f00" offset="1" />
        </linearGradient>
        <linearGradient
          id="a"
          x1="82.079"
          x2="112.51"
          y1="59.322"
          y2="76.52"
          gradientTransform="matrix(1 0 0 -1 0 134.62)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00f" offset="0" />
          <stop stopColor="#c40000" offset="1" />
        </linearGradient>
      </defs>
      <g transform="translate(-37.099 -27.677)">
        <path d="m68.849 62.072v9.2604" fill="none" stroke="#000" />
        <g
          transform="matrix(.85714 0 0 .95652 31.939 .83424)"
          strokeWidth="2.1167"
        >
          <path
            d="m43.062 55.723v-12.447l43.215-13.83 41.672 13.83v52.556h-84.887v-13.83"
            fill="none"
            stroke="#000"
            strokeWidth="1.1074"
          />
        </g>
      </g>
      <g transform="translate(-37.099 -27.677)" strokeWidth="0">
        <g>
          <rect
            x="133.67"
            y="71.333"
            width="5.2917"
            height="7.9375"
            ry="0"
            fill="url(#c)"
            fillRule="evenodd"
            style={{ paintOrder: "normal" }}
          />
          <path
            d="m133.67 71.333h-25.135l-15.875-17.198h-48.948v-2.6458l-6.6146 6.6146 6.6146 6.6146v-2.6458h46.302l15.875 17.198h27.781z"
            fill="url(#b)"
          />
        </g>
        <g>
          <path
            d="m43.714 79.27h48.948l15.875-17.198h25.135v2.6458l6.6146-6.6146-6.6146-6.6146v2.6458h-27.781l-15.875 17.198h-46.302z"
            fill="url(#a)"
          />
          <rect
            x="37.099"
            y="71.333"
            width="6.6146"
            height="7.9375"
            ry="2.2396e-7"
            fill="url(#d)"
            fillRule="evenodd"
            style={{ paintOrder: "normal" }}
          />
        </g>
      </g>
      <g transform="translate(-37.099 -27.677)">
        <g>
          <ellipse
            cx="82.079"
            cy="75.302"
            rx="7.6815"
            ry="7.6815"
            fill="#fff"
            fillRule="evenodd"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth=".5121"
            style={{ paintOrder: "normal" }}
          />
          <path
            d="m82.069 74.661a0.63916 0.64012 0 0 0-0.63917 0.64012 0.63916 0.64012 0 0 0 0.63917 0.64012 0.63916 0.64012 0 0 0 0.63915-0.64012 0.63916 0.64012 0 0 0-0.63915-0.64012m0.31958-5.7611c2.8762 0 2.9465 2.2852 1.4381 3.0406-0.63277 0.31366-0.914 0.98578-1.0354 1.5811 0.3068 0.12808 0.57524 0.32645 0.77978 0.58251 2.3649-1.2803 4.9088-0.77456 4.9088 1.5171 0 2.8805-2.2818 2.9446-3.036 1.4275-0.31959-0.63371-0.9971-0.91536-1.5915-1.037-0.12783 0.30726-0.32597 0.5697-0.58164 0.78735 1.2719 2.362 0.767 4.9033-1.5212 4.9033-2.8762 0-2.9338-2.2916-1.4253-3.047 0.62638-0.31366 0.90761-0.97938 1.0354-1.5683-0.31318-0.12796-0.58802-0.33286-0.79256-0.58891-2.3585 1.2674-4.8896 0.76815-4.8896-1.5171 0-2.8806 2.2754-2.951 3.0296-1.4339 0.31958 0.63372 0.99069 0.90897 1.5851 1.0306 0.12143-0.30726 0.32597-0.57612 0.58803-0.78094-1.2719-2.3621-0.767-4.8969 1.5084-4.8969z"
            strokeWidth=".63964"
          />
        </g>
        <g>
          <ellipse
            cx="82.079"
            cy="58.104"
            rx="7.6815"
            ry="7.6815"
            fill="#fff"
            fillRule="evenodd"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth=".5121"
            style={{ paintOrder: "normal" }}
          />
          <path
            d="m82.069 57.464a0.63916 0.64012 0 0 0-0.63917 0.64012 0.63916 0.64012 0 0 0 0.63917 0.64012 0.63916 0.64012 0 0 0 0.63915-0.64012 0.63916 0.64012 0 0 0-0.63915-0.64012m0.31958-5.7611c2.8762 0 2.9465 2.2852 1.4381 3.0406-0.63277 0.31366-0.914 0.98578-1.0354 1.5811 0.3068 0.12808 0.57524 0.32645 0.77978 0.58251 2.3649-1.2803 4.9088-0.77456 4.9088 1.5171 0 2.8805-2.2818 2.9446-3.036 1.4275-0.31959-0.63371-0.9971-0.91536-1.5915-1.037-0.12783 0.30726-0.32597 0.5697-0.58164 0.78735 1.2719 2.362 0.767 4.9033-1.5212 4.9033-2.8762 0-2.9338-2.2916-1.4253-3.047 0.62638-0.31366 0.90761-0.97938 1.0354-1.5683-0.31318-0.12796-0.58802-0.33286-0.79256-0.58891-2.3585 1.2674-4.8896 0.76815-4.8896-1.5171 0-2.8806 2.2754-2.951 3.0296-1.4339 0.31958 0.63372 0.99069 0.90897 1.5851 1.0306 0.12143-0.30726 0.32597-0.57612 0.58803-0.78094-1.2719-2.3621-0.767-4.8969 1.5084-4.8969z"
            strokeWidth=".63964"
          />
        </g>
      </g>
    </svg>
  );
};

export default Comfoair350;
